import { useState } from 'react';
import { useNavigate } from 'react-router';
import { TourProvider } from '@reactour/tour';

import TourGuidePopover from './TourGuidePopover';
import { tourSteps } from '../config';

export default function TourGuideProvider({ children }) {
  const redirect = useNavigate();
  const [step, setStep] = useState(0);

  const setCurrentStep = (newStep) => {
    redirect(tourSteps[newStep(step)].page, true);
    setTimeout(() => {
      setStep(newStep(step));
    }, 500);
  };

  return (
    <TourProvider
      steps={tourSteps}
      currentStep={step}
      setCurrentStep={setCurrentStep}
      ContentComponent={TourGuidePopover}
    >
      {children}
    </TourProvider>
  );
}
